export default "/_next/static/images/cbc46fd6457b2a5eadd7272ee9766b8e.jpg";